import { createAction, handleActions, Action } from 'redux-actions'
import { actions as authSagaActions } from '../../sagas/auth/actions'
// Name Spaced Action Types
const SHOW_LOGIN = 'Login/SHOW_LOGIN'
const HIDE_LOGIN = 'Login/HIDE_LOGIN'
const SET_AUTHORIZED = 'Login/SET_AUTHORIZED'
const RESET = 'Login/RESET'
export const actions = {
  SHOW_LOGIN,
  HIDE_LOGIN,
  SET_AUTHORIZED,
  RESET
}

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
type LoginActionCreators = {
  showLogin: () => Action<boolean>,
  hideLogin: () => Action<boolean>,
  setAuthorized: () => Action<boolean>,
  reset: () => Action<>
}

export const actionCreators: LoginActionCreators = {
  showLogin: createAction(SHOW_LOGIN),
  hideLogin: createAction(HIDE_LOGIN),
  setAuthorized: createAction(SET_AUTHORIZED),
  reset: createAction(RESET)
}

type LegalDoc = Array<{ type: string, id: string, url: string }>

type User = {
  id: string,
  current_school_id: string,
  email_validated: boolean,
  role: string
}

type LoginResponse = {
  token: string,
  user: {
    id: string,
    current_school_id: string,
    email_validated: boolean,
    role: string
  }
}

export type LoginState = {
  showLogin: boolean,
  authorized: boolean,
  user: User,
  unsignedDocs: LegalDoc,
  errors: Array<string>
}
export const initialState: LoginState = {
  showLogin: false,
  authorized: false,
  user: {},
  unsignedDocs: [],
  errors: []
}

export default handleActions(
  {
    [SET_AUTHORIZED]: (state, action: Action<boolean>) => ({
      ...state,
      authorized: action.payload
    }),
    [SHOW_LOGIN]: (state: LoginState, action: Action<boolean>) => ({
      ...state,
      showLogin: true,
      errors: []
    }),
    [HIDE_LOGIN]: (state: LoginState, action: Action<boolean>) => ({
      ...state,
      showLogin: false,
      errors: []
    }),
    [authSagaActions.LOGIN_SUCCESS]: (
      state: LoginState,
      action: Action<LoginResponse>
    ) => {
      return {
        ...state,
        showLogin: false,
        user: action.payload.user,
        authorized: true
      }
    },
    [authSagaActions.LOGIN_FAILURE]: (state: LoginState, action: Action<>) => {
      return {
        ...state,
        errors: action.payload
      }
    },
    [authSagaActions.USER_TOS_DOCS]: (
      state: LoginState,
      action: Action<LegalDoc>
    ) => ({
      ...state,
      unsignedDocs: action.payload
    }),
    [RESET]: () => {
      // window.sessionStorage.removeItem('token')
      return { ...initialState }
    }
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/redux/reducers/login/loginReducer.js